import React from "react";
import "./File.css";
import { useState, useEffect } from "react";
import { app, storage, database } from "../../firebaseConfig";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, setDoc, doc, getDoc } from "firebase/firestore";
import { upload } from "@testing-library/user-event/dist/upload";

export const File = (props) => {
  var width = document.documentElement.clientWidth;
  var now = new Date();
  const [file, setFile] = useState({});
  const [Progress, setProgress] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    if(url !== ''){
      UploadData();
    }
  }, [url])

  async function UploadData() {
    const collectionRef = doc(database, "User_Files", password);
    window.scrollTo(window.top);
    if (file.name!=null) {
      await setDoc(collectionRef, {
        Filename: file.name,
        Filesize: file.size,
        DateandTimeAdded: `${now.getDate()}-${
          now.getMonth() + 1
        }-${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
        Email: email,
        Password: password,
        _URL: url,
      })
        .then(() => {
          setTimeout(function () {
            document.getElementById("added").style.display = "none";
          }, 4000);
          document.getElementById("added").style.display = "block";
          setEmail("");
          setFile({});
          setPassword("");
        })
        .catch((err) => {
          alert(err.message);
        });
    }
    document.getElementById("progress-container").style.display = "none";
    document.getElementById("status_icon").style.display = "none";
  }

  async function Upload(e) {
    e.preventDefault();
    if (file.size>104857600){
      alert("File Size Exceeded!!!");
    }
    else{
      const collectionRef = doc(database, "User_Files", password);
      if (file.name!=null){
        const storageRef = ref(storage, file.name);
        const uploadTask = uploadBytesResumable(storageRef, file);
        console.log(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            document.getElementById("progress-container").style.display = "block";
            document.getElementById("progressTxt").style.visibility = "visible";
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            setProgress(progress);
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            console.log("File available at: ", downloadURL);
            setUrl(downloadURL);
          });
        }
      );
    }
    else {
      const Data = await getDoc(collectionRef);
      if (Data.exists()) {
        setEmail(Data.data().Email);
        setPassword(Data.data().Password);
        setUrl(Data.data()._URL);
        setTimeout(function () {
          document.getElementById("retrieved").style.display = "none";
        }, 4000);
        document.getElementById("retrieved").style.display = "block";
      } else {
        setTimeout(function () {
          document.getElementById("failed").style.display = "none";
        }, 4000);
        document.getElementById("failed").style.display = "block";
      }
    }
    }
  }

  function fileSize() {
    if (file.size >= 1073741824) {
      return (
        <p style={{ color: "rgb(255,0,0)", fontWeight: "600" }}>
          {(file.size / 1073741824).toFixed(2)} GB
        </p>
      );
    } else if (file.size <= 104857600 && file.size >= 1048576) {
      return <p>{(file.size / 1048576).toFixed(2)} MB</p>;
    } else if (file.size > 104857600) {
      return (
        <p style={{ color: "rgb(255,0,0)", fontWeight: "600" }}>
          {(file.size / 1048576).toFixed(2)} MB
        </p>
      );
    } else if (file.size >= 1024) {
      return <p>{(file.size / 1024).toFixed(2)} KB</p>;
    }
  }

  return (
    <div id="fileSection">
      <form onSubmit={Upload}>
        <div className="data">
          <label>Your Email :</label>
          <input
            type="email"
            required
            id="emailtxt"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <br />
        </div>
        <center>
          <div
            id="file_container"
            style={{display: props.download=="true"?"none":"block"}}>
            <input
              type="file"
              id="fileInput"
              onChange={(e) => {
                setFile(e.target.files[0]);
                document.getElementById("filename").style.visibility =
                  "visible";
              }}
              className="inputfile"
            />
            <label htmlFor="fileInput">
              <i
                className="fa fa-download"
                style={{ paddingRight: "10px" }}
              ></i>
              Choose a file
            </label>
            <br />
            <br />
            <span id="filename">
              <p>{file.name}</p>
            </span>
            <span id="filesize">{fileSize()}</span>
          </div>
          <p
            style={{
              color: "rgb(255,0,0)",
              fontWeight: "600",
              textAlign: "left",
              marginLeft: "10%",
              display: props.download=="true"?"none":"block"
            }}
          >
            File Size Limit: 100 MB
          </p>
          <br />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div id="progress-container" style={{display: "none"}}>
              <div id="progress-bar" style={{ width: (width<480)?Progress*2.80:Progress * 8 }}></div>
              <h4
                id="progressTxt"
                style={{ left: Progress + 1 + "%", visibility: "hidden" }}
              >
                {Math.floor(Progress)}%
              </h4>
            </div>
              <img
                id="status_icon"
                src="accept.png"
                style={{
                  width: "20px",
                  transform: "translate(225%,-15%)",
                  visibility: Progress === 100 ? "visible" : "hidden",
                  display: props.download=="true"?"none":"block"
                }}
              ></img>
          </div>
        </center>
        <br />
        <div className="data">
          {props.download=="true"?<label>Enter the Password :</label>:<label>Create a Password, as strong as you 😉 :</label>}
          
          <input
            type="password"
            required
            id="passwordtxt"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></input>
          <br />
          <br />
          <br /><br/><br/>
        </div><br/>
        <center>
          <div id="url">
            <h3 style={{display: url!=""?"block":"none"}}>Download your file here 👇 </h3>
            <a
              style={{ color: "rgb(39, 117, 225)", textDecoration: "none" }}
              href={url}
            >
              {url}
            </a>
          </div>
          <br /><br/><br/><br/><br/>
          {props.download=="true"?<button type="submit" id="upload">Download</button>:<button type="submit" id="upload">Upload</button>}
        </center>
      </form>
    </div>
  );
};
